import styled from '@emotion/styled';
import { FileReference } from '@kaizenplatform/belfast-entity';
import { DynamicSchemaFieldKey, FileIdsValue, SelectMultipleValue } from '@kaizenplatform/hugot-entity';
import { Divider as _Divider } from '@material-ui/core';
import { ClassAttributes, createElement, ReactElement } from 'react';

import { DynamicSchemaDefinition } from '../../../../generated/graphql';
import { SPACING_UNIT } from '../../../constant/spacing';
import Field from './Field';
import _Section from './Section';

// optionalでbefore, latestのProjectをうけとる
interface Props {
  definition: DynamicSchemaDefinition;
  value: {
    values: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
  };
  files: Map<DynamicSchemaFieldKey, FileReference[]>;
  latestValue: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
  beforeValue: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
  latestFiles: Map<DynamicSchemaFieldKey, FileReference[]>;
  beforeFiles: Map<DynamicSchemaFieldKey, FileReference[]>;
  className?: string;
}

const CreativeBriefDetailDiff = ({
  definition,
  value,
  files,
  latestValue,
  beforeValue,
  latestFiles,
  beforeFiles,
  className,
}: ClassAttributes<HTMLElement> & Props) => {
  const sections = definition.sections
    .reduce((whole, section) => {
      const fields = section.fields.map((field) => {
        return (
          <Field
            field={field}
            value={value.values.get(field.key) ?? null}
            files={files.get(field.key)}
            latestValue={latestValue.get(field.key) ?? null}
            beforeValue={beforeValue.get(field.key) ?? null}
            latestFiles={latestFiles.get(field.key)}
            beforeFiles={beforeFiles.get(field.key)}
            key={field.key}
          />
        );
      });

      return [
        ...whole,
        <Section section={section} key={section.id}>
          {fields}
        </Section>,
        <Divider key={`div-${section.id}`} />,
      ];
    }, [] as ReactElement<any>[])
    .slice(0, -1);

  return <div className={className}>{sections}</div>;
};

const Section = styled(_Section)({
  marginBottom: SPACING_UNIT * 3,
  ':last-child': {
    marginBottom: SPACING_UNIT,
  },
});

const Divider = styled(_Divider)({
  marginBottom: SPACING_UNIT * 3,
  ':last-child': {
    marginBottom: SPACING_UNIT,
  },
});

export default CreativeBriefDetailDiff;
